import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface Terminal {
  strCnpj: string;
  strNome: string;
  strSituacao: string;
  strTerminal: string;
  strCodigoEstabelecimento: string;
  blnPermitePagamento: boolean;
  strTelefone: string;
  strEndereco: string;
}

interface TerminalActiveState {
  addTerminal: (terminal: Terminal) => void;
  cleanData: () => void;
  removeTerminal: (strTerminal: string) => void;
  terminals: Terminal[];
}

const initialValues = {
  terminals: []
};

export const useTerminalActiveStore = create<TerminalActiveState>()(
  persist(
    (set, get) => ({
      ...initialValues,
      addTerminal: (terminal: Terminal) => {
        const { terminals, ...rest } = get();

        const isExists = terminals.some(
          (item) => item.strTerminal === terminal.strTerminal
        );

        if (!isExists) {
          terminals.push(terminal);

          set({
            ...rest,
            terminals
          });
        }
      },
      removeTerminal: (strTerminal: string) => {
        const { terminals } = get();

        const newTerminals = terminals.filter(
          (terminal) => terminal.strTerminal !== strTerminal
        );

        set({
          terminals: newTerminals
        });
      },
      cleanData: () => {
        set(initialValues);
      }
    }),
    {
      name: "TerminalActiveStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
